import { INTEGRATION_CLOSE_SIDESHEET } from '../constants'

export function closeSideSheet() {
    return async dispatch => {
        dispatch({
            type: INTEGRATION_CLOSE_SIDESHEET
        })
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case INTEGRATION_CLOSE_SIDESHEET:
            return {
                ...state,
                isSideSheetOpen: false,
            }

        default:
            return state
    }
}

